module.exports = __webpack_public_path__ + "3c6879c4f342203d099bdd66dce6d396.woff";